var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5C5 3.89543 5.89543 3 7 3C8.10457 3 9 3.89543 9 5C9 6.10457 8.10457 7 7 7C5.89543 7 5 6.10457 5 5ZM7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6C7.55228 6 8 5.55228 8 5C8 4.44772 7.55228 4 7 4ZM1.5 0C0.671573 0 0 0.671573 0 1.5V8.5C0 9.32843 0.671573 10 1.5 10H12.5C13.3284 10 14 9.32843 14 8.5V1.5C14 0.671573 13.3284 0 12.5 0H1.5ZM1 1.5C1 1.22386 1.22386 1 1.5 1H3V2C3 2.55228 2.55228 3 2 3L1 3V1.5ZM1 4L2 4C3.10457 4 4 3.10457 4 2V1H10V2C10 3.10457 10.8954 4 12 4L13 4V6H12C10.8954 6 10 6.89543 10 8V9H4V8C4 6.89543 3.10457 6 2 6H1V4ZM11 1H12.5C12.7761 1 13 1.22386 13 1.5V3L12 3C11.4477 3 11 2.55228 11 2V1ZM13 7V8.5C13 8.77614 12.7761 9 12.5 9H11V8C11 7.44772 11.4477 7 12 7H13ZM3 9H1.5C1.22386 9 1 8.77614 1 8.5V7H2C2.55228 7 3 7.44772 3 8V9ZM15.0001 8.49997C15.0001 9.88069 13.8808 11 12.5001 11H2.08545C2.29137 11.5826 2.84699 12 3.5001 12H12.5001C14.4331 12 16.0001 10.433 16.0001 8.49997V3.49997C16.0001 2.84686 15.5827 2.29125 15.0001 2.08533V8.49997Z",
    fill: "#D2D3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.da963d1e02e3f5bb308280ae16eec2af.svg";
export { ForwardRef as ReactComponent };